import { render } from "./ForgotPasswordModal.vue?vue&type=template&id=436f6116"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__